import { InputStyled } from '@components/Common/SharedStyles';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import styled from 'styled-components';
import { fi } from 'date-fns/locale';

registerLocale('fi', fi);

const PickerFix = styled.div``;

const StyledDatePicker = styled(ReactDatePicker)`
  ${InputStyled};
`;

const DatePicker: React.FC<any> = props => (
  <PickerFix>
    <StyledDatePicker
      disabled={props.isDisabled}
      isClearable={props.isClearable}
      dateFormat="dd.MM.yyyy"
      locale="fi"
      autoComplete="off"
      id={props.name}
      {...props}
    >
      {props.children}
    </StyledDatePicker>
  </PickerFix>
);

export default DatePicker;
